import React from 'react';
import {useStyles} from '@unthinkable/react-theme';
import {ToastComponent} from '@unthinkable/react-toast';
import {ToastStyles} from './theme';

export const Toast = props => {
  let styles = useStyles(ToastStyles);
  return <ToastComponent styles={styles} {...props} />;
};
